/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { DMCommonModule } from 'app/common/dm-common.module';

import { ModifyClientCifsShareComponent } from './modify-client-cifs-share.component';

@NgModule({
    declarations: [ModifyClientCifsShareComponent],
    exports: [ModifyClientCifsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        DMCommonModule,
    ],
})
export class ModifyClientCifsShareModule { }
